import { useI18n } from '@radical/locale'
import { LAYOUT } from '../basic'

const { t } = useI18n()

const stress: RouteRecordItem = {
  path: '/stress',
  name: 'Stress',
  component: LAYOUT,
  redirect: { name: 'StressDetail' },
  meta: {
    orderNo: 10,
    icon: 'mdi:car-turbocharger',
    title: t('routes.stress.压力测试'),
    hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'detail',
      name: 'StressDetail',
      component: () => import('@/pages/stress/index.vue'),
      meta: {
        title: t('routes.stress.压力测试'),
      },
    },
  ],
}

export default stress
